<footer class="bg-dark text-light  w-100  py-3" id="footer">
  <div class="container">
    <footer class="py-3">
      <div class="row">
        <div class="col-md-4">
          <div class="info-box h-100">
            <div class="contact-info h-100">
              <ul class="list-unstyled">
                <li class="d-flex flex-column mb-2">
                  <div class="d-flex flex-row">
                    <i class="bi bi-geo-alt me-2"></i>
                    <span class="text">Gateway Plaza</span>
                  </div>
                  <span class="text ms-4">25350 Magic Mountain Pkwy Suite 300</span>
                  <span class="text ms-4">Valencia, CA 91355</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="info-box h-100">
            <div class="contact-info h-100">
              <ul class="list-unstyled">
                <li class="d-flex mb-2">
                  <i class="bi bi-envelope me-2"></i>
                  <span class="text">support&#64;northstarlines.com</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="info-box h-100">
            <div class="contact-info h-100">
              <ul class="list-unstyled">
                <li class="d-flex mb-2">
                  <i class="bi bi-telephone me-2"></i>
                  <span class="text">+1 (661) 812-0513</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex flex-column flex-sm-row justify-content-center py-3 my-3 border-top">
        <p>© {{year}} North Star Lines. All rights reserved.</p>
      </div>
    </footer>
  </div>